<template>
  <Modal
    :open="displayModal"
    title="Suspend User"
    size="large"
    modalIcon="fad fa-user"
    modalIconColor="bg-blue-100 text-blue-700"
    :showEscapeButton="true"
    :showAcceptButton="true"
    acceptButtonText="Save"
    @close="displayModal = false"
    @onSuccess="updateSuspend"
    ref="modal"
  >
    <div v-if="data !== null">
      <label
        for="user_permission"
        class="block text-sm font-medium text-gray-700 mb-1"
        >Suspended</label
      >
      <select
        id="user_permission"
        name="user_permission"
        class="block w-full focus:ring-blue-500 focus:border-blue-500 border-gray-300 rounded-md"
        v-model="data.suspended"
      >
        <option :value="1">True</option>
        <option :value="0">False</option>
      </select>
    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";

import Modal from "@/components/Modal";

export default {
  data() {
    return {
      displayModal: false,
      data: null
    };
  },

  components: {
    Modal
  },

  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on("admin-user-suspend-modal-open", this.open);
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("admin-user-suspend-modal-open", this.open);
  },

  methods: {
    open(data) {
      console.log(data);
      this.displayModal = true;
      this.data = data;
    },

    async updateSuspend() {
      let response = await this.$http.post(
        Config.apiPath + "/api/v2/admin/users/" + this.data.id + "/suspend",
        { suspended: this.data.suspended }
      );
      if (response.status == 200) {
        this.$eventBus.$emit("admin-add-user-refresh-data");
        this.displayModal = false;
      }
    }
  }
};
</script>
